/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_No_DataInputs */

const es_admin_billing_last_bill_no_data = /** @type {(inputs: Admin_Billing_Last_Bill_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos aún`)
};

const en_admin_billing_last_bill_no_data = /** @type {(inputs: Admin_Billing_Last_Bill_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data yet`)
};

/**
* | output |
* | --- |
* | "No data yet" |
*
* @param {Admin_Billing_Last_Bill_No_DataInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_no_data = /** @type {((inputs?: Admin_Billing_Last_Bill_No_DataInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_No_DataInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_no_data(inputs)
	return en_admin_billing_last_bill_no_data(inputs)
});
export { admin_billing_last_bill_no_data as "admin.billing.last_bill.no_data" }